import { endPoints, API_ROOT } from "./../../../appSettings";
import { adalApiFetch } from "../../../authProvider";

export const GET_FEATURE_KEYS = "GET_FEATURE_KEYS";
export const UPLOAD_FEATURE_KEY = "UPLOAD_FEATURE_KEY";
export const DELETE_FEATURE_KEY = "DELETE_FEATURE_KEY";
export const UPDATE_FEATURE_KEY_STATUS = "UPDATE_FEATURE_KEY_STATUS";

export const GetFeatureKeys = () => {
  return (dispatch) =>
    adalApiFetch(
      fetch,
      `${API_ROOT}${endPoints.productLicense}/key/list`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      },
      dispatch
    )
      .then((response) => response.json())
      .then((json) => {
        return dispatch({
          type: GET_FEATURE_KEYS,
          payload: json,
        });
      });
};

export const UploadFeatureKey = (unitFamily, featureKey, isActive) => {
  const url = `${API_ROOT}${endPoints.productLicense}/key/upload`;
  const options = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      unit_family: unitFamily,
      key: featureKey,
      is_active: isActive,
    }),
  };

  return (dispatch) =>
    adalApiFetch(fetch, url, options, dispatch)
      .then((response) => {
        if (!response.ok) {
          return response.json().then((json) => {
            return dispatch({
              type: UPLOAD_FEATURE_KEY,
              isSuccess: false,
              payload: json,
            });
          });
        }

        return response.json().then((json) => {
          return dispatch({
            type: UPLOAD_FEATURE_KEY,
            isSuccess: true,
            payload: json,
          });
        });
      })
      .catch((error) => {
        throw Error(error);
      });
};

export const DeleteFeatureKey = (featureKey) => {
  const url = `${API_ROOT}${endPoints.productLicense}/key/${featureKey}`;
  const options = {
    method: "DELETE",
    headers: { "Content-Type": "application/json" },
  };

  return (dispatch) =>
    adalApiFetch(fetch, url, options, dispatch)
      .then((response) => {
        if (!response.ok) {
          return response.json().then((json) => {
            return dispatch({
              type: DELETE_FEATURE_KEY,
              isSuccess: false,
              payload: json,
            });
          });
        }

        return response.json().then((json) => {
          return dispatch({
            type: DELETE_FEATURE_KEY,
            isSuccess: true,
            payload: json,
          });
        });
      })
      .catch((error) => {
        throw Error(error);
      });
};

export const UpdateFeatureKeyStatus = (featureKey, isActive) => {
  const url = `${API_ROOT}${endPoints.productLicense}/key/${featureKey}/${isActive}`;
  const options = {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
  };

  return (dispatch) =>
    adalApiFetch(fetch, url, options, dispatch)
      .then((response) => {
        if (!response.ok) {
          return response.json().then((json) => {
            return dispatch({
              type: UPDATE_FEATURE_KEY_STATUS,
              isSuccess: false,
              payload: json,
            });
          });
        }

        return response.json().then((json) => {
          return dispatch({
            type: UPDATE_FEATURE_KEY_STATUS,
            isSuccess: true,
            payload: json,
          });
        });
      })
      .catch((error) => {
        throw Error(error);
      });
};

export const GetActivityLogs = (
  startDate,
  endDate,
  page = 1,
  limit = 10,
  sort = 0,
  order = 1,
  search = "",
  activity = 0,
  searchBy = 0,
  operation = 0
) => {
  return (dispatch) => {
    return adalApiFetch(
      fetch,
      `${API_ROOT}${endPoints.productLicense}/key${endPoints.activityLogs}?page=${page}&limit=${limit}&startDate=${startDate}&endDate=${endDate}&sortby=${sort}&orderby=${order}&searchtext=${search}&activity=${activity}&searchby=${searchBy}&operation=${operation}`,
      {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      },
      dispatch
    ).then((response) => response.json());
  };
};
